/**
 * Shared analytics query params (date + System Admin company scope).
 * Persists company selection so detail pages keep the same filter as the hub.
 */

const COMPANY_STORAGE_KEY = 'analytics_selected_company';
const HUB_STORAGE_KEY = 'analytics_location_hub_id';
const USER_STORAGE_KEY = 'analytics_user_id';

export const getStoredAnalyticsHub = () => {
  try {
    return sessionStorage.getItem(HUB_STORAGE_KEY) || '';
  } catch {
    return '';
  }
};

export const setStoredAnalyticsHub = (hubId) => {
  try {
    if (hubId == null || hubId === '') sessionStorage.removeItem(HUB_STORAGE_KEY);
    else sessionStorage.setItem(HUB_STORAGE_KEY, String(hubId));
  } catch {
    /* ignore */
  }
};

export const getStoredAnalyticsUser = () => {
  try {
    return sessionStorage.getItem(USER_STORAGE_KEY) || '';
  } catch {
    return '';
  }
};

export const setStoredAnalyticsUser = (userId) => {
  try {
    if (userId == null || userId === '') sessionStorage.removeItem(USER_STORAGE_KEY);
    else sessionStorage.setItem(USER_STORAGE_KEY, String(userId));
  } catch {
    /* ignore */
  }
};

export const getStoredAnalyticsCompany = () => {
  try {
    const raw = sessionStorage.getItem(COMPANY_STORAGE_KEY);
    if (raw == null || raw === '') return 'all';
    return raw === 'all' ? 'all' : raw;
  } catch {
    return 'all';
  }
};

export const setStoredAnalyticsCompany = (companyId) => {
  try {
    if (companyId == null || companyId === '' || companyId === 'all') {
      sessionStorage.setItem(COMPANY_STORAGE_KEY, 'all');
    } else {
      sessionStorage.setItem(COMPANY_STORAGE_KEY, String(companyId));
    }
  } catch {
    /* ignore */
  }
};

export const isSystemAdminUser = (user) => {
  const role = user?.role_name || user?.role?.role_name || user?.role;
  return role === 'System Admin';
};

/**
 * Build params for /api/analytics/* calls.
 * @param {{ filter: string, customDates?: {from_date?: string, to_date?: string}, selectedCompany?: string|number, currentUser?: object, extra?: object }} opts
 */
export const buildAnalyticsParams = ({
  filter,
  customDates = {},
  selectedCompany = 'all',
  currentUser = null,
  extra = {},
} = {}) => {
  const params =
    filter === 'custom'
      ? { filter, from_date: customDates.from_date, to_date: customDates.to_date }
      : { filter };

  if (
    isSystemAdminUser(currentUser) &&
    selectedCompany != null &&
    selectedCompany !== '' &&
    selectedCompany !== 'all'
  ) {
    params.company_id = selectedCompany;
  }

  const hubId = getStoredAnalyticsHub();
  const userId = getStoredAnalyticsUser();
  if (hubId) params.location_hub_id = hubId;
  if (userId) params.user_id = userId;

  Object.entries(extra || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      params[key] = value;
    }
  });

  return params;
};
